// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__1ryMT","Open":"SideDrawer_Open__3psvE","Close":"SideDrawer_Close__1XwTB","Logo":"SideDrawer_Logo__3QDV9"};